<template>
    <v-card >
        <v-toolbar
          color="primary"
          dark
          extended

        >

        </v-toolbar>

        <v-container>
            <v-row>
                <v-col cols="6">
                    <v-card
                    class="mx-auto"
                    max-width="700"
                    style="margin-top: -64px;"
                  >
                    <v-toolbar color="success" dark >
                      <v-toolbar-title class="white--text">
                        Актив
                      </v-toolbar-title>

                      <v-spacer></v-spacer>


                      {{ activ_total }} TJS
                    </v-toolbar>
                    <v-divider></v-divider>

                    <v-card-text >

                        <v-expansion-panels

                        multiple
                        >
                        <v-expansion-panel  >

                            <v-expansion-panel-header disable-icon-rotate color="success"  class="white--text">
                                Остаток денежных средств
                                <template v-slot:actions>
                                    {{ nal_total }} TJS &nbsp; &nbsp;
                                  <v-icon class="white--text">
                                    mdi-plus
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                        Наличными
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ Number(nal).toFixed(2) }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                        Душанбе сити
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ Number(dc).toFixed(2) }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                        Эсхата
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ Number(eskhata).toFixed(2) }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                             dense
                             outlined
                             dark
                             class="m-2"
                              >

                             <v-row align="center">
                                 <v-col class="grow">
                                     Алиф
                                 </v-col>
                                 <v-col class="shrink">
                                    {{ Number(alif).toFixed(2) }}
                                 </v-col>
                             </v-row>
                          </v-alert>



                            </v-expansion-panel-content>
                        </v-expansion-panel>


                        <v-expansion-panel  >

                            <v-expansion-panel-header disable-icon-rotate color="success"  class="white--text">
                                Остаток товаров ({{ molho_total }}TJS)
                                <template v-slot:actions>
                                    {{ molho_total }} TJS &nbsp; &nbsp;
                                  <v-icon class="white--text">
                                    mdi-plus
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         TJS
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ molho_tjs }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         USD
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ molho_usd }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                             dense
                             outlined
                             dark
                             class="m-2"
                              >

                             <v-row align="center">
                                 <v-col class="grow">
                                      RUB
                                 </v-col>
                                 <v-col class="shrink">
                                     {{ molho_rub }}
                                 </v-col>
                             </v-row>
                          </v-alert>

                            </v-expansion-panel-content>
                        </v-expansion-panel>


                        <v-expansion-panel  >

                            <v-expansion-panel-header disable-icon-rotate color="success"  class="white--text">
                                Долги клиетов
                                <template v-slot:actions>
                                    {{ klent_total }} TJS &nbsp; &nbsp;
                                  <v-icon class="white--text">
                                    mdi-plus
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         TJS
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ klent_tjs }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         USD
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ klent_usd }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="primary"
                             dense
                             outlined
                             dark
                             class="m-2"
                              >

                             <v-row align="center">
                                 <v-col class="grow">
                                      RUB
                                 </v-col>
                                 <v-col class="shrink">
                                     {{ klent_rub }}
                                 </v-col>
                             </v-row>
                          </v-alert>

                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        </v-expansion-panels>




                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="6">
                    <v-card
                    class="mx-auto"
                    max-width="700"
                    style="margin-top: -64px;"
                  >
                    <v-toolbar  color="error" dark>
                      <v-toolbar-title class="white--text" >
                        Пассив
                      </v-toolbar-title>

                      <v-spacer></v-spacer>


                      {{ passiv_total }} TJS
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-card-text >
                        <v-expansion-panels

                        multiple
                        >
                        <v-expansion-panel  >

                            <v-expansion-panel-header disable-icon-rotate color="error"  class="white--text">
                                Задолженность перед поставщиками
                                <template v-slot:actions>
                                    {{ firma_total }} TJS &nbsp; &nbsp;
                                  <v-icon class="white--text">
                                    mdi-minus
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-alert type="error"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         TJS
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ Number( firma_tjs).toFixed(2) }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="error"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         USD
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ firma_usd }}
                                    </v-col>
                                </v-row>
                             </v-alert>

                             <v-alert type="error"
                             dense
                             outlined
                             dark
                             class="m-2"
                              >

                             <v-row align="center">
                                 <v-col class="grow">
                                      RUB
                                 </v-col>
                                 <v-col class="shrink">
                                     {{ firma_rub }}
                                 </v-col>
                             </v-row>
                          </v-alert>



                            </v-expansion-panel-content>
                        </v-expansion-panel>



                        <v-expansion-panel  >

                            <v-expansion-panel-header disable-icon-rotate color="error"  class="white--text">
                                Доход
                                <template v-slot:actions>
                                    {{ dokhod }} TJS &nbsp;
                                  <v-icon class="white--text">
                                    mdi-minus
                                  </v-icon>
                                </template>
                              </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-alert type="error"
                                dense
                                outlined
                                dark
                                class="m-2"
                                 >

                                <v-row align="center">
                                    <v-col class="grow">
                                         TJS
                                    </v-col>
                                    <v-col class="shrink">
                                        {{ dokhod }}
                                    </v-col>
                                </v-row>
                             </v-alert>



                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        </v-expansion-panels>

                    </v-card-text>
                  </v-card>
                </v-col>
            </v-row>
        </v-container>




      </v-card>
</template>

<script>
import { tSParenthesizedType } from '@babel/types';

export default {

    data: () => ({

        panel: [0, 0],
        readonly: false,

        alif:0,
        eskhata:0,
        dc:0,
        nal:0,
        nal_total:0,
        loading:false,
        molho_usd:0,
        molho_rub:0,
        molho_tjs:0,
        molho_tjs:0,
        molho_total:0,

        klent_usd:0,
        klent_rub:0,
        klent_tjs:0,
        klent_total: 0,
        activ_total:0,

        firma_usd:0,
        firma_rub:0,
        firma_tjs:0,
        firma_total: 0,
        dokhod:0,
        passiv_total:0,
    }
    ),

    mounted(){

    this.get_balans()


    },

    methods:{
        get_balans(){
            axios.get('/api/get_balans',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.$session.start();
                            var kurs_usd = Number( this.$session.get('usd'))
                            var kurs_rub = Number(this.$session.get('rub'))

                            this.loading = false;
                            this.alif = response.data.alif;
                            this.eskhata = response.data.eskhata
                            this.dc = response.data.dc
                            this.nal = response.data.nal
                            this.nal_total =  Number(Number(this.nal)+Number(this.alif)+Number(this.eskhata)+Number(this.dc)).toFixed(2);

                            this.molho_tjs = Number( response.data.molho_tjs).toFixed(2)
                            this.molho_usd = Number(response.data.molho_usd).toFixed(2)
                            this.molho_rub = Number(response.data.molho_rub).toFixed(2)

                            var molho_usd_tjs = Number(this.molho_usd * kurs_usd).toFixed(2);
                            var molho_rub_tjs = Number(this.molho_rub * kurs_rub).toFixed(2);

                            this.molho_total = Number(Number(molho_usd_tjs)+Number(molho_rub_tjs) + Number(this.molho_tjs)).toFixed(2)

                            this.klent_tjs = Number(response.data.klent_tjs).toFixed(2)
                            this.klent_usd = Number(response.data.klent_usd).toFixed(2)
                            this.klent_rub = Number(response.data.klent_rub).toFixed(2)

                            var klent_usd_tjs = Number(this.klent_usd * kurs_usd).toFixed(2);
                            var klent_rub_tjs = Number(this.klent_rub * kurs_rub).toFixed(2);
                            this.klent_total = Number(Number(klent_usd_tjs)+Number(klent_rub_tjs) + Number(this.klent_tjs)).toFixed(2)

                            this.activ_total  =Number(Number(this.nal_total) + Number(this.molho_total)+Number(this.klent_total)).toFixed(2)

                            this.firma_tjs = response.data.firma_tjs
                            this.firma_usd = response.data.firma_usd
                            this.firma_rub = response.data.firma_rub

                            var firma_usd_tjs = Number(this.firma_usd * kurs_usd).toFixed(2);
                            var firma_rub_tjs = Number(this.firma_rub * kurs_rub).toFixed(2);
                            this.firma_total = Number(Number(firma_usd_tjs)+Number(firma_rub_tjs) + Number(this.firma_tjs)).toFixed(2)


                            this.dokhod = Number(Number(this.activ_total) - Number(this.firma_total)).toFixed(2)
                            this.passiv_total = Number(Number(this.dokhod) + Number(this.firma_total)).toFixed(2);
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                    });
        }
    }

}
</script>

<style>

</style>
